import $ from 'jquery';
import { View } from 'backbone';
import Template from 'report/properties/main/field-type.ejs';

class MainFieldTypeView extends View {

    initialize( opts ) {
        this.options = opts || {};
        this.template = Template;
        this.tagName = 'div';
        this.id = opts.el;

        this.events = {
            "change .type": 'updateRadioAttributes'
        };

        this.listenTo(this.model, 'change', this.render);
        return this;
    }

    updateRadioAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal = ev.currentTarget.value;

        this.model.set( propName, propVal ); 
    }

    render() {
        this.$el.empty();
        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }
        $("input[value='" + this.model.get('type') + "']").prop('checked',true);

        this.delegateEvents(); 
        return this;
    }
}

export default MainFieldTypeView;
